import React, { useState } from "react";
import useCloudfrontImage from "../utils/useCloudfrontImage";

let { appname } = window.app;

// Loader shown in place of table rows while a list is fetching. Same fallback
// rules as <Loader />: never an empty box, never a broken image.
const TableLoader = () => {
    const image = useCloudfrontImage();
    const [imageFailed, setImageFailed] = useState(false);

    return (
        <div className="table-preloader">
            <div className="orasi-preloader">
                {image && !imageFailed ? (
                    <img
                        src={`${image}${appname}/images/web/Loader.svg`}
                        alt=""
                        onError={() => setImageFailed(true)}
                    />
                ) : (
                    <span className="spot-loader-spinner" role="status" aria-label="Loading" />
                )}
            </div>
        </div>
    );
};

export default TableLoader;
